export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";